import { module } from 'angular';
import App from '../../../app';

class SCR1905Controller {
	
	constructor ($scope, $uibModalInstance, $timeout, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.httpService = httpService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(740, 560);
		this.initText();
		
		this.showResult(this.data);
		
//		this.$timeout(() => {
//			const $importFile = $('input:file');
//			
//			$importFile.on('change', (event) => {
//				const $importFile = $('input:file');
//				const files = $importFile[0].files;
//				
//				if(files === undefined) return;
//				if(files.length > 10) {
//					$importFile.val('');
//					this.popupService.simpleAlert(this.$scope, "파일은 10개까지 업로드할 수 있습니다.");
//					return;
//				}
//				
//				let fileNames = '';
//				
//				for(let i = 0; i < files.length; i++) {
//					fileNames += '[' + (i+1) + '] ' + files[i].name + '\r\n';
//				}
//				
//				$('.filenames').val(fileNames);
//			});
//		});
		
		
		
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			interfaceImport : bxMsg('manageMciInterface.interfaceImport'),
			interfaceFile : bxMsg('manageMciInterface.interfaceFile'),
			errorMessage : bxMsg('common.errorMessage'),
			close : bxMsg('common.close'),
			batchDeployResult : bxMsg('common.batchDeployResult')
		}
	}
	
	showResult(data){
		
		let filterResponse = data.resList.filter(v => v.res);
		this.allLen=0;
		this.successCnt = 0;
		this.failCnt = 0;
		
		filterResponse.map((data) => {
			if(data.res.status === 'SUCCESS') {
				this.successCnt++;
			}else {
				this.failCnt++;
			}
		});
		
		this.allLen= this.successCnt + this.failCnt
		
		 this.isError = false;
		 this.testList = data.resList.map((data) => {
			 let fileConts = '';
			 data.intrfcId && (fileConts += '인터페이스 ID : ');
			 data.intrfcId && (fileConts += data.intrfcId + ' ');
			 data.res.status && (fileConts += '배포결과 : ');
			 data.res.status && (fileConts += data.res.status + '\r\n');
			 data.res.data && (fileConts += data.res.data.message + '\r\n');
			 data.res.intrfcDeployResponse && (fileConts += data.res.intrfcDeployResponse.map((param) => {
				 return '아래 에러는 공정에 문의 하세요.'+'\r\n'+'['+'배포시스템 : '+param.systemCd+' /'+' 배포대상시스템 : '+param.deployStatus + ' /' + ' message : '+param.message+']'+ '\r\n';
				 }));
			 
			 return {
				isError: data.res.status == 'SUCCESS' ? false : true,
				fileName: data.intrfcId,
				fileConts: fileConts
			 };
		 });
	}
	
	toggle(fileIndex, isError) {
		if(!isError) return;
		
		let $fileConts = $('#file' + fileIndex);
		
		if($fileConts.is(':visible')){
			$fileConts.hide();
		}else{
			$fileConts.show();
		}
	}
	
	openFile() {
		this.reset();
		$('input:file').click();
	}
	
	reset(){
		$('.filenames').val('');
		$('input:file').val('');
		this.isError = false;
		this.testList = [];
		this.uploadResult = ' ';
		this.uploadResultMsg = ' ';
	}
	
	closeModal(isOk){
		this.$uibModalInstance.dismiss();
	}
}

module(App.name).controller('SCR1905Controller', SCR1905Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1905/SCR1905.controller.js